<template>
	<div class="scroll-progress-cont">
		<div class="scroll-progress-texts stack-horizontal" data-align="center" data-justify="spaced">
			<p class="font-caption capitalize-first">{{scrollyName}}  {{currStageName.length ? '•' : ''}}  <span class="font-medium">{{utils.capitalizeFirst(currStageName)}}</span></p>
			<div v-if="historicalMoment" class="scroll-historical-moment font-caption">{{'['+utils.capitalizeFirst(historicalMoment)+']'}}</div>
		</div>
		<div class="scroll-progress-line relative">
			<div class="scroll-stage-progress"></div>
		</div>
	</div>
</template>

<script type="text/javascript">

import utils from '@js/utils.js';
	
export default {
	name: 'InterfaceProgressBar',
	props: {
		scrollyName: {
			type: String,
			default: ''
		},
		currStageName: {
			type: String,
			default: ''
		},
		historicalMoment: {
			type: String,
			default: ''
		},
		currStageSectionIndex: {
			type: Number,
			default: 0
		},
		currStageNumSections: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			utils
		}
	},
	methods: {
		manageProgressStage() {
			window.requestAnimationFrame(() => {
				let amount = 0;
				let widthBar = document.querySelector('.scroll-progress-cont').getBoundingClientRect().width
				amount = utils.map(this.currStageSectionIndex+1, 0, this.currStageNumSections, 0, widthBar )
				document.querySelector('.scroll-stage-progress').style.transform = `translateX(calc(100% * -1 + ${amount}px))`;
			})
			// document.querySelector('.scroll-stage-progress').style.width = amount + 'px';
		},
	},
	mounted() {
		this.manageProgressStage();
	}
}

</script>